import React, { Component } from 'react';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import selectors from '../../selectors';
import Select from 'react-select-plus';
import { Icon } from '@mgc/react-components';
import PropTypes, { string } from 'prop-types';
import MapPropTypes from '../MapPropTypes';
import strings from '../../strings';
import './Selector.scss';
import * as format from '../../format';
import AlertToggle from './AlertToggle';
import SiteActions from '../../actions/sites';
import { Grid, Col, Row } from 'react-bootstrap';

class AddHostServer extends Component {
    
    constructor(props) {
        super(props)
    
        this.state = {
            disabled: true, 
            serverInput: '',
            hostInput: '',  
            cleared: false,                 
        }        
    }

    static propTypes = {
        sites: PropTypes.arrayOf(PropTypes.object),
        selectedSite: PropTypes.object,
        selectedSiteId: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        selectSite: PropTypes.func.isRequired,
        showAlertToggle: PropTypes.func,        
        // showAlert: PropTypes.bool,
        // serverId: PropTypes.string,
        // hostId: PropTypes.string,
    };

    // constructor() {
    //     super();
    //     this._closeAlert = this._closeAlert.bind(this);
    // }

    static mapState = (state) =>
        mapSelectors(state, {
            // site
            showAlert: selectors.sites.showAlert,
            serverId: selectors.sites.getServerId,
            hostId: selectors.sites.getHostId,
            toggleMessage: selectors.sites.getAlertMessage,
            offer: selectors.offer.getSelectedOffer,
        });

    static mapDispatch = (dispatch) => ({
        showAlertToggle: (boolValue) =>
            dispatch(SiteActions.showAlert(boolValue)),
        setServerId: (serverId) => dispatch(SiteActions.setServerId(serverId)),
        setHostId: (hostId) => dispatch(SiteActions.setHostId(hostId)),
        setErrorMessage: (message, errorType) =>
            dispatch(SiteActions.setErrorMessage(message, errorType)),
        handleAddServerHostButtonClick: (siteId, hostId, serverId, offerId) =>
            dispatch(
                SiteActions.validateThroughLightHouseAPI(
                    siteId,
                    hostId != '' ? hostId : null,
                    serverId != '' ? serverId : null,
                    offerId
                )
            ),
    });

    _handleSiteSelection(option) {
        if (!option) {
            this.props.selectSite(-1);
        } else {
            this.props.selectSite(option.value);
            this.setState({disabled : false});
        }
    }

    _handleOnServerIdChanged(value) {        
        this.props.setServerId(value);
        this.setState({disabled : this._isButtonDisabled(), serverInput: value});
    }

    _handleOnHostIdChange(value) {
        this.props.setHostId(value);
        this.setState({disabled : this._isButtonDisabled(), hostInput: value});
    }

    _renderOption(option) {
        return (
            <span>
                {option.value}
                <small className="text-mute"> #{option.label}</small>
            </span>
        );
    }

    _getSiteOptions() {
        if (!this.props.sites) {
            return [];
        }

        return this.props.sites.map((site, i) => ({
            label: format.siteLabel(site),
            value: site.mentorId,
        }));
    }

    _getSelectedOption() {
        if (this._isButtonDisabled()) {
            return -1;
        }

        return this.props.selectedSiteId;
    }

    _isButtonDisabled() {
        var disabled = false;
        if (
            this.props.selectedSiteId == -1 ||
            this.props.selectedSiteId == ''
        ) {
            disabled = true;
        }
        return disabled;
    }

    _getInputClasses(field_type) {
        const classes = [];

        if (field_type !== 'select' && field_type !== 'checkbox') {
            classes.push('form-control');
        }

        if (field_type === 'date') {
            classes.push('datepicker');
            classes.push('flatpickr-input');
        }

        if (this.props.hasError) {
            classes.push('form-control-error');
        } else if (this.props.isChanged) {
            classes.push('form-control-success');
        }

        return classes.join(' ');
    }

    _handleAddServerHostButtonClick() {
        if (this.props.showAlert == true) {
            this.props.showAlertToggle(false);
        }

        if (
            /*If site is selected*/
            this.props.selectedSiteId != -1 &&
            this.props.selectedSiteId != '' &&
            this.props.hostId != '' &&
            this.props.serverId != ''
        ) {
            this.setState({disabled : true, cleared: false});
            this.props.handleAddServerHostButtonClick(
                this.props.selectedSiteId,
                this.props.hostId,
                this.props.serverId,
                this.props.offer.id
            );            
        }else  if (
            /*If site is selected*/
            this.props.selectedSiteId != -1 &&
            this.props.selectedSiteId != ''
        ) {
            /*If both host and server are not selected/empty */
            if (this.props.hostId == '' && this.props.serverId == '') {
                this.props.setErrorMessage(
                    strings.serverOrHostRequired,
                    strings.danger
                );
                this.props.showAlertToggle(true);
            } else if (this.props.hostId != '' || this.props.serverId != '') {
                this.setState({disabled : true, cleared: false});
                this.props.handleAddServerHostButtonClick(
                    this.props.selectedSiteId,
                    this.props.hostId,
                    this.props.serverId,
                    this.props.offer.id
                );
            }
        } else if (
            /* If site is not selected*/
            this.props.selectedSiteId == -1 ||
            this.props.selectedSiteId == ''
        ) {
            this.props.setErrorMessage(
                strings.siteIdRequired,
                strings.danger
            );
            this.props.showAlertToggle(true);            
        }
    }

    _closeAlert() {
        if (this.props.showAlert == true) {
            this.props.showAlertToggle(false);
        }
    }

    _renderTab(tab) {
        return (
            <li className="nav-item text-sm" key={String(Math.random())}>
                <a role="tab" onClick={() => this._handleClick(true)}>
                    Super
                </a>
            </li>
        );
    }

    _checkAlert(){
        if(this.props.showAlert && !this.state.cleared 
            && this.props.toggleMessage.message === '["Server / Host successfully added to the site"]'){
            this.setState({serverInput: '', hostInput: '', cleared: true});
            this.props.setServerId('');
            this.props.setHostId('');
        }
        return this.props.toggleMessage;
    }

    render() {
        return (
            <div className="card raised-sm border-none product-selector">
                <div className="card-header card-header-info text-inverse">
                    <b>{strings.addHostServer}</b>
                </div>

                <div className="card-block">
                    <Grid>
                        <Row>
                            <AlertToggle
                                showAlert={this.props.showAlert}
                                bStyleClass={this.props.bStyleClass}
                                message={this._checkAlert()}
                                closeAlert={this.props.showAlertToggle}
                            />
                        </Row>
                        <Row className="show-grid">
                            <Col xs={7} md={5}>
                                <div className="">
                                    <Select
                                        multi={false}
                                        placeholder={
                                            strings.selectSiteForNewServer +
                                            '...'
                                        }
                                        clearable={!this._isButtonDisabled()}
                                        value={this._getSelectedOption()}
                                        options={this._getSiteOptions()}
                                        onChange={(s) =>
                                            this._handleSiteSelection(s)
                                        }
                                        valueRenderer={(o) =>
                                            this._renderOption(o)
                                        }
                                        optionRenderer={(o) =>
                                            this._renderOption(o)
                                        }
                                    />
                                </div>
                            </Col>
                            <Col xs={6} md={4}>
                                <div>
                                    <input
                                        id="host_id"
                                        type="text"
                                        placeholder="Enter a Host Name"
                                        value={this.state.hostInput}
                                        className={this._getInputClasses(
                                            'text'
                                        )}
                                        onChange={(val) =>
                                            this._handleOnHostIdChange(
                                                val.target.value.trim()
                                            )
                                        }
                                    />
                                </div>
                            </Col>
                            <Col xs={3} md={3}>
                                <div>
                                    <input
                                        id="server_id"
                                        type="text"
                                        placeholder="Enter a Host ID"
                                        className={this._getInputClasses()}
                                        value={this.state.serverInput}
                                        onChange={(val) =>
                                            this._handleOnServerIdChanged(
                                                val.target.value.trim()
                                            )
                                        }
                                    />
                                </div>
                            </Col>
                        </Row>
                        <span>&nbsp;</span>
                        <Row className="show-grid">
                            <Col xs={2} xsOffset={10}>
                                <div className="input-group-btn">
                                    <button
                                        onClick={() =>
                                            this._handleAddServerHostButtonClick()
                                        }
                                        // onClick={() => this._handleClick(true)}
                                        disabled={this.state.disabled}
                                        className="btn btn-primary btn-lg btn-block configure-button"
                                    >
                                        {strings.submit}
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </Grid>
                </div>
            </div>
        );
    }
}
export default attach(AddHostServer);



// WEBPACK FOOTER //
// ./app/components/OrderForm/AddHostServer.jsx